import Tooltip from 'src/components/tooltip-wrapper/tooltip';
import css from './contact-card.module.scss';
import { Contact, ContactType } from 'src/types';
import { toast } from 'react-toastify';
import { ReactComponent as CopyIcon } from 'src/assets/ContentCopy.svg';
import { ReactComponent as EmailIcon } from 'src/assets/email.svg';
import { ReactComponent as PhoneIcon } from 'src/assets/map/phone.svg';
import { ReactComponent as AwayIcon } from 'src/assets/away.svg';

export default function ContactIcon({ contact }: Readonly<{ contact: Contact }>) {
  function copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    toast.success('Скопійовано в буфер обміну');
  }

  const sendEmail = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    window.location.href = `mailto:${contact.value}`;
    e.preventDefault();
  };
  const icon = () => {
    switch (contact.contactType) {
      case ContactType.Email:
        return (
          <Tooltip text={`Відправити лист на ${contact.value}`}>
            <button tabIndex={0} className={css.actionIcon} onClick={sendEmail}>
              <EmailIcon />
            </button>
          </Tooltip>
        );
      case ContactType.Phone:
        return (
          <Tooltip text={`Зателефонувати на ${contact.value}`}>
            <a className={css.actionIcon} href={'tel:' + contact.value.replace(/\s/g, '')}>
              <PhoneIcon />
            </a>
          </Tooltip>
        );
      case ContactType.Link:
        return (
          <Tooltip text={`Перейти за посиланням ${contact.value}`}>
            <a className={css.away_icon} href={contact.value}>
              <AwayIcon />
            </a>
          </Tooltip>
        );
      default:
        return <></>;
    }
  };

  return (
    <span className={css.icons}>
      {icon()}
      <Tooltip text='Скопіювати контакт'>
        <button tabIndex={0} className={css.actionIcon} onClick={() => copyToClipboard(contact.value)}>
          <CopyIcon />
        </button>
      </Tooltip>
    </span>
  );
}
